export const NOTIFICATION_STATUSES = {
  UNKNOWN: 'UNKNOWN',
  PUBLISH: 'PUBLISH',
  IN_PROGRESS: 'IN_PROGRESS',
  DRAFT: 'DRAFT',
  CANCEL: 'CANCEL',
  FAILED: 'FAILED',
}
